export default function initM21() {
    const $ = jQuery;
    const slider = $(".slick-agencyWork");

    slider.slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        focusOnSelect: true,
        infinite: true,
        vertical: true,
        verticalSwiping: true,
        responsive: [
            {
                breakpoint: 767,
                settings: {
                    dots: true,
                }
            }
        ]
    });

    let debounceTimer;

    // Wheel event listener with debounce
    slider.on('wheel', function (e) {
        e.preventDefault();

        clearTimeout(debounceTimer); // Clear previous debounce timer
        debounceTimer = setTimeout(() => {
            if (e.originalEvent.deltaY < 0) {
                $(this).slick('slickPrev'); // Move to the previous slide
            } else {
                $(this).slick('slickNext'); // Move to the next slide
            }
        }, 40); // Adjust debounce duration as needed
    });

    // Optionally, add logic for custom scroll bar
    const scrollset = () => {
        const totalSlides = slider.slick("getSlick").slideCount;
        const parentHeight = $(".scroll-content").outerHeight();
        const barHeight = (parentHeight / totalSlides);
        const barHeightPercentage = (barHeight / parentHeight) * 100;
        $('.slide-bar').css("height", barHeightPercentage + "%");
        for (let index = 0; index < totalSlides; index++) {
            $(`.slide-bar-${index}`).css("top", (barHeightPercentage * index) + '%');
        }
    };

    slider.on("afterChange", scrollset);
    scrollset();
}
